module.exports = __webpack_public_path__ + "media/images/consumer/account/upcoming-menus/promo-banners/less-prep/dish@1x-8978b62239f2a506e1d0b5dfc647c410.png";